import image from "./image.vue";
/**
 * @param  {VueInstance} Vue
 * @param  {Object} [options={}]
 */
const install = function(Vue) {
	Vue.component("image-loader", image);
};

export default {
	install,
};
